import {
  type MetricResultCell,
  type MetricResultColumn,
} from '@myre/app-agent-domain/registry/result-block';
import { SimpleCellType, type CellSimpleCell } from '@myre/common-sheet';

/**
 * One cell for the sheet, read off the column the ENTRY declared.
 *
 * An `identifier` stays a string even though it is written with digits: it has
 * no magnitude, so the numeric rendering would group its thousands and turn
 * asset 1234 into "1 234". A number that means a quantity keeps its numeric
 * type, so the primitive right-aligns and formats it.
 *
 * An absent value stays absent, which the sheet renders as a dash rather than
 * as the word "null".
 */
export function toSheetCell(
  value: MetricResultCell,
  column: MetricResultColumn,
): CellSimpleCell {
  if (typeof value === 'number' && column.kind !== 'identifier') {
    return { value, type: SimpleCellType.Amount };
  }

  return {
    type: SimpleCellType.String,
    value: value === null ? '' : String(value),
  };
}
